<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <app-header-noauth class="appHeader appHeader--sticky appHeader--noauth"></app-header-noauth>
  <mat-card>
    <mat-card-title><h1>Política de cookies</h1></mat-card-title>
    <div class="content">
      <h2>¿Qué son las cookies?</h2>
      <p>
        Este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan información cuando navegas.
        En general, estas tecnologías pueden servir para finalidades muy diversas, como, por ejemplo, reconocerte como
        usuario, obtener información sobre tus hábitos de navegación, o personalizar la forma en que se muestra el
        contenido. Los usos concretos que hacemos de estas tecnologías se describen a continuación.
      </p>
      <h3>¿Qué tipos de cookies utilizamos?</h3>

      <mat-table [dataSource]="dataSourceTypeCookies" class="typeCookies">
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <strong>{{ element.type }}</strong></mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <p *ngIf="element.type !== 'Cookies persistentes'">
              {{ element.description }}
            </p>
            <p *ngIf="element.type === 'Cookies persistentes'">
              {{ element.description }} <a href="javascript:void(0)" (click)="goFinallyTable()">su finalidad.</a>
            </p>
          </mat-cell>
        </ng-container>
        <mat-row *matRowDef="let row; columns: displayedColumnsTypeCookies"></mat-row>
      </mat-table>

      <h3 id="finally">Cookies según su finalidad</h3>

      <mat-table [dataSource]="dataSourceTypeCookies2" class="typeCookies2">
        <ng-container matColumnDef="purpose">
          <mat-header-cell *matHeaderCellDef>Finalidad</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <strong>{{ element.purpose }}</strong></mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>Descripción</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.description }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="thirdParty">
          <mat-header-cell *matHeaderCellDef>Editor</mat-header-cell>
          <mat-cell *matCellDef="let element" [innerHTML]="element.thirdParty"></mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumnsTypeCookies2"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsTypeCookies2"></mat-row>
      </mat-table>

      <h2>Configuración de las cookies</h2>
      <p>
        Desde el <a href="javascript:void(0)" onclick="OneTrust.ToggleInfoDisplay()">configurador de cookies</a>, puedes
        configurar manual e individualmente tu selección en base a tus preferencias.
      </p>
      <h3>Gestión del uso de cookies en mi navegador</h3>
      <p>
        En cualquier momento puedes permitir, bloquear o eliminar las cookies, así como borrar los datos de navegación
        desde tu navegador. Para ello, consulta las opciones e instrucciones que ofrece tu navegador instalado:
      </p>
      <ul>
        <li>
          <a
            href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
            target="_blank"
            >Configuración de cookies de Internet Explorer</a
          >
        </li>
        <li>
          <a
            href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we&redirectlocale=es"
            target="_blank"
            >Configuración de cookies de Firefox</a
          >
        </li>
        <li>
          <a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank"
            >Configuración de cookies de Google Chrome</a
          >
        </li>
        <li>
          <a href="https://www.apple.com/legal/privacy/es/cookies/" target="_blank"
            >Configuración de cookies de Safari</a
          >
        </li>
      </ul>
      <p>
        Estos navegadores están sometidos a actualizaciones o modificaciones, por lo que no podemos garantizar que se
        ajusten completamente a la versión de su navegador. También puede ser que utilice otro navegador no contemplado
        en estos enlaces como Konqueror, Arora, Flock, etc. Para evitar estos desajustes, puede acceder directamente
        desde las opciones de su navegador, generalmente en el menú de "Opciones" en la sección de "Privacidad". (Por
        favor, consulte la ayuda de su navegador para más información.)
      </p>
      <h3>Revocación del consentimiento</h3>
      <p>
        También es posible limitar como las webs de terceros instalan cookies en su ordenador, para evitar la
        recolección de datos y registro de su actividad de navegación. Para limitar el uso de cookies de terceros puede
        dirigirse a la web de configuración u OptOut:
      </p>
      <ul>
        <li><a href="https://tools.google.com/dlpage/gaoptout?hl=None" target="_blank">Google Analytics</a></li>
        <li>
          <a
            href="https://support.google.com/My-Ad-Center-Help/answer/12155656?visit_id=638429136174161091-258082794&rd=1"
            target="_blank"
            >DoubleClick</a
          >
        </li>
        <li><a href="https://myadcenter.google.com/home?sasb=true&ref=ad-settings" target="_blank">Google</a></li>
      </ul>
      <p>
        Seleccione la opción “Eliminar todos los sitios” o seleccione la web específica que desee borrar y “Eliminar
        Sitio Web”.
      </p>
      <p>
        Esta política se revisa periódicamente para asegurar su vigencia, por lo que puede ser modificada. Le
        recomendamos que visite la página con regularidad, donde le informaremos de cualquier actualización al respecto.
        Para obtener mayor información sobre el tratamiento de sus datos personales al margen de la instalación de
        cookies en su terminal puede visitar "
        <strong>
          <a
            target="_blank"
            href="https://www.sabadellconsumer.com/cs/Satellite?blobcol=urldata&amp;blobheader=application%2Fpdf&amp;blobheadername1=Content-disposition&amp;blobheadervalue1=attachment%3B+filename%3DANEXO_PROTECCION_DATOS.PDF&amp;blobkey=id&amp;blobtable=MungoBlobs&amp;blobwhere=8000806913986&amp;bsb=R0JTX011bHRpbWVkaWFfRkEtNjAwMDE3MzMyMTc5MC0xMTgzMDE1NjQwMzU1&amp;ssbinary=true"
            title="el anexo de información detallada sobre protección de datos de carácter personal"
            >el anexo de información detallada sobre protección de datos de carácter personal</a
          > </strong
        >".
      </p>
    </div>
  </mat-card>
  <!-- FOOTER -->
  <app-footer class="appFooter appFooter--noauth"></app-footer>
</div>
